import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QuestionAnswer, TopicAnswers } from '@app/_models';
import { CourseService } from '@app/_services/course.service';
import { TopicShareService } from '@app/_services/topic.share.service';
import { first } from 'rxjs/operators';

@Component({ templateUrl: 'flower.component.html', selector: 'flower' })
export class FlowerComponent {

    assessmentResultText: string;
    resultText: string;

    @Input() answers: any[];
    @Input() mode: string;


    ngOnChanges(changes) {
        let answersValues = changes.answers.currentValue;

        let value1 = 1;
        let value16 = 1.6;
        let value23 = 2.3;
        let value3 = 3;

        let value1Count = { length: answersValues.filter((v) => (v === value1)).length, value: 1 };
        let value16Count = { length: answersValues.filter((v) => (v === value16)).length, value: 1.6 };
        let value23Count = { length: answersValues.filter((v) => (v === value23)).length, value: 2.3 };
        let value3Count = { length: answersValues.filter((v) => (v === value3)).length, value: 3 };

        let mostAppearedValue = [value1Count, value16Count, value23Count, value3Count].sort((one, two) => (one.length > two.length ? -1 : 1))[0];

        switch (mostAppearedValue.value) {
            case 1:
                this.assessmentResultText = 'Seeding';
                this.resultText = " It’s an exciting time for you. You are just starting out on your equity journey. You will begin to learn more about you, and how equity applies to your life and work.";
                break;
            case 1.6:
                this.assessmentResultText = 'Sprouting';
                this.resultText = "You’re on your way! You have an awareness of what is needed to practice equity, and you’re ready to begin.";
                break;
            case 2.3:
                this.assessmentResultText = 'Blooming';
                this.resultText = "You’re nearly there! You’ve decided that equity is important and have started to implement equitable practices. You may be wondering where to go from here and what other practices you might incorporate."
                break;
            case 3:
                this.assessmentResultText = 'Full Bloom';
                this.resultText = "You’ve really blossomed! Equity is very important to you because it shows in how you run your company and live your life. Now, you’re ready to evaluate the effectiveness of your practices and adapt them. You’re also in a position to determine how to best help other companies and entrepreneurs benefit from what you’ve planted.";
                break;
        }
    }

}
